import React, { memo } from "react";
import "./style.scss";
import Select from "react-select";

const Html = ({isLoading,options, selectedValues, handleChange, displayValue, id,className='',placeholder='',disabled,required }) => {
  let _options = options?.map((itm) => {
    return { value: itm?.id, label: itm?.[displayValue] };
  });

  if (_options?.length > 1 && options?.length - selectedValues?.length > 1) {
    _options = [
      {
        value: "all",
        label: "Select All",
      },
    ].concat(_options);
  }

  return (
    <>
      <div className="selectDropdown">
        <Select
          defaultValue={displayValue}
          isMulti
          value={selectedValues || []}
          // options={
          //   options?.map((itm) => {
          //     return { value: itm.id, label: itm[displayValue] };
          //   }) || []
          // }
          placeholder={placeholder}
          options={_options}
          className={`basic-multi-select select_multi ${className}`}
          // classNamePrefix={`select ${className}`}
          onChange={(e) => handleChange(e)}
          isDisabled={disabled}
          isLoading={isLoading}
          required={required}
        />
      </div>
    </>
  );
};

export default memo(Html);
